import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isMarketingDomain } from '../utils/domain';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-7VTTYHBXF5';

/**
 * Hook to track page views in Google Analytics for SPA navigation.
 * Only tracks on hr4india.com marketing site, not on okrhub subdomain.
 *
 * Usage: Call this hook once in a component inside BrowserRouter
 */
export const useGoogleAnalytics = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Only the marketing hosts are counted. This is isMarketingDomain and NOT
    // `!isAppDomain`: the previous "anything that is not okrhub.*" rule also matched
    // localhost, so developer page views were reported to the live GA property.
    if (!isMarketingDomain()) {
      return;
    }

    // Ensure gtag is available
    if (typeof window.gtag !== 'function') {
      return;
    }

    // Send page view event
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);
};
